import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons"
import { Flex, Radio, Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type AlbumsView } from "../../../../../../Album/helpers/albums-view-preference.ts"
import { type AlbumSortOrder } from "../../../../../../Album/types/album-sort.types.ts"
import { type AlbumsFilters } from "../../../../../../Album/redux/album.types.ts"
import { SearchBar } from "../../../../../../../components/Input/SearchBar.tsx"
import { AlbumsSortSelect } from "./AlbumsSortSelect.tsx"

const VISIBILITY_OPTIONS = [
  { value: null, label: "All" },
  { value: "true", label: "Visible to client" },
  { value: "false", label: "Hidden" }
]

interface ProjectAlbumsFiltersProps {
  filters: AlbumsFilters
  showVisibilityFilter: boolean
  onFiltersChange: (data: Partial<AlbumsFilters>) => void
  sortValue: AlbumSortOrder
  onSortChange: (value: AlbumSortOrder) => void
  view: AlbumsView
  onViewChange: (view: AlbumsView) => void
}

export function ProjectAlbumsFilters({
  filters,
  showVisibilityFilter,
  onFiltersChange,
  sortValue,
  onSortChange,
  view,
  onViewChange
}: ProjectAlbumsFiltersProps) {
  const { t } = useTranslation()

  const onFilterChange = (key: keyof AlbumsFilters) => (value: unknown) => {
    onFiltersChange({ [key]: value || null })
  }

  return (
    <Flex justify="space-between" align="center" wrap="wrap" gap="small">
      <SearchBar
        placeholder={t("files.albums.searchPlaceholder")}
        className="w-48 md:w-64"
        defaultValue={filters?.q || ""}
        onSearch={onFilterChange("q")}
      />

      <Flex align="center" gap={12}>
        {showVisibilityFilter && (
          <Select
            value={filters?.is_visible_to_customer || null}
            style={{ width: 150 }}
            onChange={onFilterChange("is_visible_to_customer")}
            options={VISIBILITY_OPTIONS}
          />
        )}
        <AlbumsSortSelect value={sortValue} onChange={onSortChange} />
        <Radio.Group
          value={view}
          onChange={(e) => onViewChange(e.target.value)}
          optionType="button"
          options={[
            {
              label: (
                <span aria-label={t("files.albums.view.grid")}>
                  <AppstoreOutlined />
                </span>
              ),
              value: "grid"
            },
            {
              label: (
                <span aria-label={t("files.albums.view.list")}>
                  <BarsOutlined />
                </span>
              ),
              value: "list"
            }
          ]}
        />
      </Flex>
    </Flex>
  )
}
